import React, { useMemo } from 'react'
import SelectField, { SelectProps } from './select'
import { TextFieldProps } from '@material-ui/core/TextField'
import withTableWrapper from './withTableWrapper'
import withInlineWrapper from './withInlineWrapper'
import isEmpty from 'lodash/isEmpty'

interface Item {
  code: string
  name: string
}

interface Option {
  id: string
  name: string
}

interface TranslatedItemSelectProps {
  name: string
  label?: string
  required?: boolean
  items: Item[]
  AutocompleteProps?: Omit<SelectProps<object>['AutocompleteProps'], 'getOptionLabel' | 'options'>
  TextFieldProps?: Omit<TextFieldProps, 'label' | 'required'>
}

const TranslatedItemSelectField: React.FC<TranslatedItemSelectProps> = ({
  name,
  label,
  items,
  required = false,
  AutocompleteProps,
  TextFieldProps
}) => {
  const options = useMemo(() => items.map((item) => ({ id: item?.code, name: item?.name })), [items])

  return (
    <SelectField
      name={name}
      AutocompleteProps={{
        getOptionLabel: (option: Option) => option?.name || '',
        options: options,
        ...AutocompleteProps
      }}
      TextFieldProps={{
        label: label,
        required: required,
        ...TextFieldProps
      }}
    />
  )
}

const getSelectFieldValue = (value: { id: string; name: string } | null): string => {
  if (value !== null) {
    const { name } = value

    return isEmpty(name) ? '-' : name
  }

  return '-'
}

export const TranslatedItemInlineSelectField = withInlineWrapper(TranslatedItemSelectField, getSelectFieldValue, {
  isSelect: true,
  autoFocus: false
})
export const TranslatedItemInlineSelectFieldWithShadow = withInlineWrapper(TranslatedItemSelectField, getSelectFieldValue, {
  isSelect: true,
  autoFocus: false,
  showShadow: true
})
export const TableTranslatedItemInlineSelectField = withTableWrapper(TranslatedItemInlineSelectField)

export default TranslatedItemSelectField
